import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import React from "react";

export interface FooterLinkProps {
  href: string;
  label: string;
  badge?: string;
}

export const FooterLink = ({ href, label, badge }: FooterLinkProps) => {
  return (
    <li className="mb-xl last:mb-0">
      <a
        href={href}
        className="no-underline text-xs-regular text-primary-on-brand hover:text-secondary-on-brand hover:no-underline"
      >
        <span
          className={cn({
            "mr-md": !!badge,
          })}
        >
          {label}
        </span>
        {badge && (
          <Badge className="bg-button-primary-bg border-none rounded-sm text-xs-regular font-normal text-secondary-on-brand hover:text-secondary-on-brand">
            {badge}
          </Badge>
        )}
      </a>
    </li>
  );
};
